import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { EventismCredit } from "@/components/Brand";
import { api } from "@/lib/api";

export default function Footer() {
  const [livePods, setLivePods] = useState([]);

  useEffect(() => {
    api.get("/pods")
      .then(({ data }) => setLivePods((data.items || []).filter((p) => p.status === "active")))
      .catch(() => {});
  }, []);

  return (
    <footer
      id="location"
      className="bg-brand-blue text-white pt-16 pb-8 border-t-8 border-brand-red mt-12"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-white p-2 rounded-lg text-brand-blue">
                <i className="fas fa-bolt text-2xl" />
              </div>
              <span className="text-2xl font-black tracking-tightest uppercase">
                Party Rentals <span className="italic text-brand-gold">Express</span>
              </span>
            </div>
            <p className="text-slate-300 font-medium max-w-md leading-relaxed text-sm">
              Denver&apos;s first fully automated self-service rental pod network. Commercial-grade
              event gear without the warehouse wait. Rent. Unlock. Celebrate.
            </p>
            <div className="mt-6">
              <EventismCredit inverted />
            </div>
          </div>

          <div>
            <h4 className="font-black text-brand-gold uppercase tracking-widest text-[10px] mb-4">
              Rental Locations
            </h4>
            {livePods.length === 0 ? (
              <p className="text-sm font-bold text-slate-400">Locations coming soon.</p>
            ) : (
              <ul className="space-y-3" data-testid="footer-rental-locations">
                {livePods.map((p) => (
                  <li key={p.slug}>
                    <Link
                      to={`/pods/${p.slug}`}
                      className="flex items-start text-sm font-bold hover:text-brand-gold transition-colors"
                      data-testid={`footer-pod-link-${p.slug}`}
                    >
                      <i className="fas fa-map-marker-alt text-brand-red mr-3 mt-1" />
                      <span>
                        <span className="block font-black uppercase tracking-tight">{p.name}</span>
                        <span className="block text-[11px] text-slate-300 font-medium">{p.address}</span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            )}
            <Link
              to="/locations"
              className="mt-4 inline-flex items-center gap-1.5 text-[10px] font-black uppercase tracking-widest text-brand-gold hover:text-white transition-colors"
              data-testid="footer-all-locations-link"
            >
              View All Locations <i className="fas fa-arrow-right" />
            </Link>
          </div>

          <div>
            <h4 className="font-black text-brand-gold uppercase tracking-widest text-[10px] mb-4">
              Support
            </h4>
            <a
              href="tel:720-907-4044"
              className="flex items-center text-sm font-bold hover:text-brand-red transition-colors"
              data-testid="footer-phone-link"
            >
              <i className="fas fa-phone mr-3" />
              720-907-4044
            </a>
            <a
              href="https://eventism.com"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 flex items-center text-sm font-bold hover:text-brand-gold transition-colors"
              data-testid="footer-eventism-link"
            >
              <i className="fas fa-external-link-alt mr-3" />
              eventism.com
            </a>
            <div className="mt-6 space-y-1.5 text-[11px] font-bold">
              <Link to="/how-it-works" className="block hover:text-brand-gold transition-colors" data-testid="footer-how-link">
                How It Works
              </Link>
              <Link to="/inventory" className="block hover:text-brand-gold transition-colors" data-testid="footer-inventory-link">
                Inventory
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 text-center">
          <p className="text-[10px] text-slate-400 font-black uppercase tracking-[0.4em]">
            &copy; {new Date().getFullYear()} Party Rentals Express
          </p>
        </div>
      </div>
    </footer>
  );
}
